/**
 * What the colours and the dashes mean.
 *
 * A diagram that distinguishes two things by colour and does not say which is
 * which has not distinguished them. Small, and shared by both hierarchies so
 * neither can grow a colour the other does not explain.
 */

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

export interface LegendItem {
  tone: 'primary' | 'secondary' | 'warning' | 'error'
  label: string
  /** Drawn as a dashed outline, matching how the diagram marks an orphan. */
  dashed?: boolean
}

export default function Legend({ items }: { items: LegendItem[] }) {
  const theme = useTheme()
  return (
    <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', alignItems: 'center' }}>
      {items.map((item) => (
        <Stack key={item.label} direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
          <svg width={18} height={12} aria-hidden="true">
            <rect
              x={1}
              y={1}
              width={16}
              height={10}
              rx={2}
              fill="none"
              stroke={theme.palette[item.tone].main}
              strokeWidth={1.5}
              strokeDasharray={item.dashed ? '3 2' : undefined}
            />
          </svg>
          <Typography variant="caption" color="text.secondary">
            {item.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}
